import {SET_TOTAL_UNREAD_ENTRIES} from '../types';

function actionSetTotalUnreadEntries(totalUnreadEntries)
{
    return {
        type: SET_TOTAL_UNREAD_ENTRIES,
        payload: totalUnreadEntries
    };
}

export default actionSetTotalUnreadEntries;


// WEBPACK FOOTER //
// ./redux/actions/totalUnreadEntries/actionSetTotalUnreadEntries.js